import { useLocation } from '@ui/app-router';
// import { isProduction } from '@ui/environment';
import { useEffect } from 'react';
import { pageview, trackEvent } from '../../lib/gtm';
// Re-export for convenience
export { pageview, trackEvent };
/** Tracks route changes and sends pageviews to GA4. GTM is initialized in bootstrap.tsx before React mounts. */ export function GoogleTagManager(param) {
    let { children } = param;
    const location = useLocation();
    // Track pageviews on route changes
    useEffect(()=>{
        // if (!isProduction) return;
        pageview(location.pathname);
    }, [
        location.pathname
    ]);
    return children;
}
